import React from 'react';
import { InputNumber, Space } from 'antd';
import styles from '../../../event-timeline.module.css';

interface TimeDelayParamsProps {
  params: any;
  setParams: (params: any) => void;
}

const TimeDelayParams: React.FC<TimeDelayParamsProps> = ({
  params,
  setParams,
}) => {
  return (
    <div className={styles.parameterContainer}>
      <Space direction='vertical' style={{ width: '100%' }}>
        <span className={styles.label}>Delay (ms):</span>
        <InputNumber
          value={params.delay}
          onChange={(value) => setParams({ ...params, delay: value })}
          min={0}
          style={{ width: '100%' }}
        />
      </Space>
    </div>
  );
};

export default TimeDelayParams;
